import { SxProps } from '@mui/material';

export const inputsBox: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#ffffff',
  width: '100%',
  mt: '28px',
  borderRadius: '8px',
  boxShadow: '2px 2px 32px rgba(0, 0, 0, 0.06)',
  p: '32px',
  gap: '32px',
};

export const sendBtn: SxProps = {
  backgroundColor: 'rgba(0, 119, 214, 1)',
  height: '41px',
  '&:hover': {
    backgroundColor: 'rgba(0, 102, 185, 1)',
  },
  fontSize: '13px',
  color: 'white',
  lineHeight: '1',
  fontWeight: 600,
  display: 'flex',
  gap: '8px',
  justifyContent: 'center',
  alignItems: 'center',
  p: '12px 16px',
  borderRadius: '6px',

  '& .MuiSvgIcon-root': {
    width: '16px',
    height: '16px',
  },
};
